import { jsxs, jsx } from 'react/jsx-runtime';
import { Label } from '@headlessui/react';
import { Text } from '../Text/Text.js';
import baseStyles from './InputBase.module.css.js';

function InputBaseLabel({ label, required, }) {
    if (!label) {
        return null;
    }
    return (jsxs(Label, { className: baseStyles.Label, passive: true, children: [jsx(Text, { prominence: "secondary", children: label }), required ?
                jsx(Text, { accent: "error", children: " *" })
                : null] }));
}

export { InputBaseLabel };
//# sourceMappingURL=InputBaseLabel.js.map
